import type { Theme } from '@/@types/theme';
import { themePix365Colors } from '@/themes/brandColors/pix365';

export const ThemePix365: Theme = {
  name: 'pix365',
  dark: true,
  colors: themePix365Colors,
};
